import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import DomainStrip from "./components/DomainStrip";
import MirrorIndex from "./components/MirrorIndex";
import UpdateLog from "./components/UpdateLog";
import AntiLossGuide from "./components/AntiLossGuide";
import CollectionShowcase from "./components/CollectionShowcase";
import Faq from "./components/Faq";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />

        <div className="w-full bg-foreground-950">
          <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8 py-3 flex items-center gap-3 overflow-hidden">
            <span className="shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] bg-accent-500 text-accent-950 whitespace-nowrap">
              <i className="ri-notification-3-line"></i>
              重要
            </span>
            <p className="text-[13px] text-background-200 truncate">
              北美线路临时维护，预计 24 小时内恢复；主域与香港节点一切正常，可放心使用。
            </p>
            <a
              href="#updates"
              className="ml-auto shrink-0 text-[12px] text-primary-300 hover:text-primary-200 cursor-pointer whitespace-nowrap hidden sm:inline-flex items-center gap-1"
            >
              查看更新日志
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <DomainStrip />
        <MirrorIndex />
        <UpdateLog />
        <AntiLossGuide />
        <CollectionShowcase />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}